export default function officeApiIsAsyncMethodSupported(asyncMethodName: string) {
  const contextComponents = asyncMethodName.split('.')

  let currentContext: any
  if (contextComponents[0] === 'Office') {
    currentContext = Office
    contextComponents.shift()
  } else {
    currentContext = Office.context.mailbox.item
  }

  for (let i = 0; i < contextComponents.length; i++) {
    const contextComponent = contextComponents[i]
    if (!contextComponent) {
      return false
    } else if (!currentContext[contextComponent]) {
      return false
    } else {
      currentContext = currentContext[contextComponent]
    }
  }

  return true
}
